import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { LuEye, LuEyeOff } from "react-icons/lu";
import FloatingInput from "./FloatingInput";

export default function FloatingPasswordInput({ id, label, value, onChange, required, error }) {
  const [visible, setVisible] = useState(false);

  return (
    <FloatingInput
      id={id}
      label={label}
      required={required}
      type={visible ? "text" : "password"}
      value={value}
      onChange={onChange}
      error={error}
      endAdornment={
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          className="text-slate-400 transition-colors hover:text-slate-200"
          tabIndex={-1}
          aria-label={visible ? "Hide password" : "Show password"}
        >
          <AnimatePresence mode="wait" initial={false}>
            <motion.span
              key={visible ? "visible" : "hidden"}
              initial={{ opacity: 0, rotate: -45 }}
              animate={{ opacity: 1, rotate: 0 }}
              exit={{ opacity: 0, rotate: 45 }}
              transition={{ duration: 0.15 }}
              className="flex"
            >
              {visible ? <LuEyeOff size={18} /> : <LuEye size={18} />}
            </motion.span>
          </AnimatePresence>
        </button>
      }
    />
  );
}